module.exports = __webpack_public_path__ + "img/ksm.0409b44c.png";